import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useTheme } from 'widgets/theme-switcher/index'

function WhenTheme (props) {
  const theme = useTheme()
  const { type, children } = props

  if (!theme) {
    return null
  }

  return theme.get() === type ? children : null
}

export default observer(WhenTheme)

WhenTheme.defaultProps = {
  type: null
}

WhenTheme.propTypes = {
  type: PropTypes.string.isRequired
}
